import { useTranslation } from 'react-i18next';

import { AppBar, Button } from '@mui/material';

import { formSubmitButtonStyle } from './formSubmitButtonStyle';

interface FormSubmitButtonProps {
  matchesMD: boolean;
  isDisabled: boolean;
}
export const FormSubmitButton = ({ matchesMD, isDisabled }: FormSubmitButtonProps) => {
  const { t } = useTranslation();

  return (matchesMD
    ? (
      <Button
        fullWidth
        variant="contained"
        disabled={isDisabled}
        type="submit"
        sx={formSubmitButtonStyle.desktopButton}
      >
        {t('formSubmitButton')}
      </Button>
    )
    : (
      <AppBar
        position="fixed"
        elevation={3}
        sx={formSubmitButtonStyle.mobileFixedButton}
      >
        <Button
          fullWidth
          variant="contained"
          disabled={isDisabled}
          type="submit"
          sx={formSubmitButtonStyle.mobileButton}
        >
          {t('formSubmitButton')}
        </Button>
      </AppBar>
    ));
};
